import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const TikTok = React.lazy(() => import('./TikTok'));

export default class TikTokWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <TikTok
            config={this.props.config}
            reportEvent={this.props.reportEvent(this.props.config.id)}
          />
        </Suspense>
      </div>
    );
  }
}

TikTokWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  reportEvent: PropTypes.func,
};
